import React, { useState, useEffect, useRef } from 'react';

// 상수 정의
const NAVBAR_HEIGHT = 120;
const SCROLL_THRESHOLD = 5; // 최소 스크롤 거리
const BUTTON_HIDE_DELAY = 3000; // 버튼 숨김 지연 시간 (3초)

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

const scrollToComments = () => {
  const comments = document.getElementById('comments-section');
  if (comments) {
    const rect = comments.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const offset = rect.top + scrollTop - NAVBAR_HEIGHT - 10;
    window.scrollTo({ top: offset, behavior: 'smooth' });
  } else {
    window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
  }
};

// 스타일 객체 정의
const buttonStyle = {
  position: 'fixed',
  right: '24px',
  zIndex: 9999,
  border: 'none',
  borderRadius: '50%',
  width: '36px',
  height: '36px',
  marginBottom: '8px',
  background: 'none',
  color: '#fff',
  cursor: 'pointer',
  transition: 'all 0.3s ease-in-out',
};

const buttonHoverStyle = {
  background: '#ff6b35',
  boxShadow: '0 4px 12px rgba(255, 107, 53, 0.39)',
};

const containerStyle = {
  position: 'fixed',
  right: 20,
  bottom: 28,
  display: 'flex',
  flexDirection: 'column',
  gap: 6,
  zIndex: 9999
};

const imageStyle = { width: 40, height: 40 };

const ScrollToButtons = () => {
  const [hovered, setHovered] = useState({ up: false, down: false });
  const [showButtons, setShowButtons] = useState({ up: false, down: false });
  const upTimeoutRef = useRef(null);
  const downTimeoutRef = useRef(null);
  const lastScrollYRef = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const prevScrollY = lastScrollYRef.current;
      const scrollDiff = Math.abs(currentScrollY - prevScrollY);
      
      // 최소 스크롤 거리 체크 (불필요한 업데이트 방지)
      if (scrollDiff < SCROLL_THRESHOLD) return;
      
      const scrollDirection = currentScrollY > prevScrollY ? 'down' : 'up';
      
      // 스크롤 방향에 따라 해당 버튼 표시
      if (scrollDirection === 'down') {
        setShowButtons(prev => ({ ...prev, down: true }));
        // 기존 타이머 클리어 후 새 타이머 설정
        if (downTimeoutRef.current) {
          clearTimeout(downTimeoutRef.current);
        }
        downTimeoutRef.current = setTimeout(() => {
          setShowButtons(prev => ({ ...prev, down: false }));
          downTimeoutRef.current = null;
        }, BUTTON_HIDE_DELAY);
      } else if (scrollDirection === 'up') {
        setShowButtons(prev => ({ ...prev, up: true }));
        // 기존 타이머 클리어 후 새 타이머 설정
        if (upTimeoutRef.current) {
          clearTimeout(upTimeoutRef.current);
        }
        upTimeoutRef.current = setTimeout(() => {
          setShowButtons(prev => ({ ...prev, up: false }));
          upTimeoutRef.current = null;
        }, BUTTON_HIDE_DELAY);
      }
      
      lastScrollYRef.current = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      // 컴포넌트 언마운트 시 타이머 정리
      if (upTimeoutRef.current) {
        clearTimeout(upTimeoutRef.current);
      }
      if (downTimeoutRef.current) {
        clearTimeout(downTimeoutRef.current);
      }
    };
  }, []);

  return (
    <div style={containerStyle}>
      <button
        aria-label="맨 위로"
        style={{
          ...buttonStyle,
          bottom: 60,
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          opacity: showButtons.up ? 1 : 0,
          visibility: showButtons.up ? 'visible' : 'hidden',
          transform: showButtons.up ? 'scale(1)' : 'scale(0.8)',
          ...(hovered.up ? buttonHoverStyle : {})
        }}
        onClick={scrollToTop}
        title="맨 위로"
        onMouseEnter={() => setHovered(h => ({ ...h, up: true }))}
        onMouseLeave={() => setHovered(h => ({ ...h, up: false }))}
      >
        <img src={require('../assets/upbutton.webp')} alt="맨 위로" style={imageStyle} />
      </button>
      <button
        aria-label="맨 아래로"
        style={{
          ...buttonStyle,
          bottom: 20,
          padding: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          opacity: showButtons.down ? 1 : 0,
          visibility: showButtons.down ? 'visible' : 'hidden',
          transform: showButtons.down ? 'scale(1)' : 'scale(0.8)',
          ...(hovered.down ? buttonHoverStyle : {})
        }}
        onClick={scrollToComments}
        title="맨 아래로"
        onMouseEnter={() => setHovered(h => ({ ...h, down: true }))}
        onMouseLeave={() => setHovered(h => ({ ...h, down: false }))}
      >
        <img src={require('../assets/downbutton.webp')} alt="맨 아래로" style={imageStyle} />
      </button>
    </div>
  );
};

export default ScrollToButtons;
